export default __webpack_public_path__ + "static/media/Pe-icon-7-stroke.7233a7ae.ttf";